// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ClawbackReceiverDelegation } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Clawback';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

export const useClawbackReceiverDelegations: () => UseQueryResult<
  TemplateContract<ClawbackReceiverDelegation>[],
  string
> = () =>
  useOperatorBasedQuery('queryClawbackReceiverDelegations', (ledgerApi, offset, operator) =>
    ledgerApi.queryClawbackReceiverDelegation(offset, operator),
  );

const delegationsByDelegator = (data?: TemplateContract<ClawbackReceiverDelegation>[]) => {
  const res = {} as { [key: string]: TemplateContract<ClawbackReceiverDelegation> };
  (data || []).forEach((d) => {
    res[d.payload.delegator] = d;
  });
  return res;
};

export const useClawbackReceiverDelegationsByParty = () => {
  const clawbackReceiverQuery = useClawbackReceiverDelegations();

  return delegationsByDelegator(clawbackReceiverQuery.data);
};
